import React from 'react'
import T from 'prop-types'
import { styled } from '@mui/material/styles'
import { Button, Dialog, IconButton, Link } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import { getUrlWithCorrectProtocol } from 'lib/getCarPictures'
import axios from 'axios'

import config from '../../../config'

import CarDetailsCarousel from './CarDetailsCarousel'

const classes = {
  linkShow: 'link-show',
  btnShow: 'btn-show',
  btnClose: 'btn-close',
  slideShowModal: 'slideShow-modal',
  modalWrapper: 'modal-wrapper',
  carImage: 'car-image',
}
const StyledLink = styled(Link)(({ theme }) => ({
  [`&.${classes.linkShow}`]: {
    position: 'relative',
    display: 'block',
  },
  [`& .${classes.carImage}`]: {
    display: 'block',
    width: '100%',
    borderRadius: theme.shape.borderRadius,
  },
  [`& .${classes.btnShow}`]: {
    position: 'absolute',
    bottom: theme.spacing(1),
    right: theme.spacing(1),
  },
}))

const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${classes.modalWrapper}`]: {
    backgroundColor: theme.palette.common.black,
  },
  [`& .${classes.btnClose}`]: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
  },
}))

export default function CarDetailsImageWithCarousel({ car, readOnly }) {
  const { t } = useTranslation()
  const [pictures, setPictures] = React.useState([])

  const [open, setOpen] = React.useState(false)

  const handleOpen = async () => {
    const results = await axios.get(
      `${config.apiBaseUrl}cars/${car.vin}/images`
    )
    setPictures(
      results.data.body.images.map((image) => ({
        original: image,
        thumbnail: image,
      }))
    )

    setOpen(true)
  }

  const handleClose = () => {
    setPictures([])
    setOpen(false)
  }
  return (
    <div>
      <StyledLink
        onClick={handleOpen}
        component="button"
        className={classes.linkShow}
      >
        <img
          src={getUrlWithCorrectProtocol(car.pictureurl)}
          className={classes.carImage}
          alt={car.title}
        />
        <Button
          variant="contained"
          color="secondary"
          className={classes.btnShow}
          component="a"
        >
          {t('carDetails.showAllPhotos', {
            attribute: pictures.length,
          })}
        </Button>
      </StyledLink>
      {open && (
        <StyledDialog
          fullScreen
          open={open}
          onClose={handleClose}
          className={classes.slideShowModal}
          PaperProps={{ className: classes.modalWrapper }}
          // TransitionComponent={Transition}
        >
          <IconButton
            edge="start"
            color="secondary"
            onClick={handleClose}
            aria-label="close"
            className={classes.btnClose}
          >
            <CloseIcon />
          </IconButton>
          <CarDetailsCarousel car={car} pictures={pictures} />
        </StyledDialog>
      )}
    </div>
  )
}

CarDetailsImageWithCarousel.propTypes = {
  car: T.object.isRequired,
  readOnly: T.bool,
}
